import React from 'react';
import {connect} from "react-redux";
import UserInfos from '../../../shared/pages/userInfos';

class Block1 extends React.Component {

    render() {
        return (
            <div style={{padding:20}}>
                <UserInfos user ={this.props.infos}/><br/>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {infos: store.salarie.infos}
}

export default connect(mapStateToProps)(Block1);


// WEBPACK FOOTER //
// ./src/components/salarie/bodies/indexBlocks/Block1.js